import { apiClient } from 'common/clients/api.client.ts';
import { API_ENDPOINTS, API_URL } from 'common/constants/api-endpoints.constants.ts';
import {
  IOffRampReq,
  IOffRampRes,
  IOnRampReq,
  IOnRampRes,
  IOrderFlowDataReq,
  IOrderFlowDataRes,
  IOrderRampQueryParams,
  IOrderRampRes,
  IRatesReq,
  IRatesRes,
  ISubmitDemoWalletReq,
  ISubmitDemoWalletRes,
} from 'domains/on-off-ramp/interfaces/on-off-ramp.interfaces.ts';

export const getOrderFlowDataService = async (reqData: IOrderFlowDataReq): Promise<IOrderFlowDataRes> => {
  const { signature } = reqData;
  const url = API_ENDPOINTS.ON_OFF_RAMP.ORDER_FLOW;
  const config = {
    params: {
      signature,
    },
  };
  const res = await apiClient.get<IOrderFlowDataRes>(url, config);

  return res.data;
};

export const postOnRampService = async (reqData: IOnRampReq): Promise<IOnRampRes> => {
  const url = API_ENDPOINTS.ON_OFF_RAMP.ON_RAMP;
  const res = await apiClient.post<IOnRampRes>(url, reqData);

  return res.data;
};

export const postOffRampService = async (reqData: IOffRampReq): Promise<IOffRampRes> => {
  const url = API_ENDPOINTS.ON_OFF_RAMP.OFF_RAMP;
  const res = await apiClient.post<IOffRampRes>(url, reqData);

  return res.data;
};

export const getRatesService = async (params: IRatesReq): Promise<IRatesRes> => {
  const url = API_ENDPOINTS.ON_OFF_RAMP.RATES;
  const config = {
    params,
  };
  const res = await apiClient.get<IRatesRes>(url, config);

  return res.data;
};

export const submitDemoWalletService = async (params: ISubmitDemoWalletReq): Promise<ISubmitDemoWalletRes> => {
  const url = `${API_URL}${API_ENDPOINTS.ON_OFF_RAMP.DEMO_WALLET_CREATE}`;
  const config = {
    params,
  };
  const res = await apiClient.get<ISubmitDemoWalletRes>(url, config);

  return res.data;
};

export const getOrderRampService = async (params: IOrderRampQueryParams): Promise<IOrderRampRes> => {
  const url = API_ENDPOINTS.ON_OFF_RAMP.ORDER_RAMP;
  const config = {
    params,
  };
  const res = await apiClient.get<IOrderRampRes>(url, config);

  return res.data;
};
